import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { computedFn } from 'mobx-utils/lib/computedFn';
import { constructKeytip, getKeytipString } from 'owa-command-ribbon';
import { getComposeRibbonId } from 'owa-compose-ribbon-utils/lib/utils/getComposeRibbonId';
import type { ComposeViewState } from 'owa-mail-compose-store';
import { getControlInfo } from 'owa-mail-ribbon-utils';
import { MailRibbonControlId, MailRibbonTabId } from 'owa-ribbon-ids';
import { onPollButtonClicked } from '../../../util/commandActions';
import { createMailAppButton } from '../../../util/createMailRibbonButton';
export const getPollControl = computedFn(
    (popoutComposeViewState: ComposeViewState | undefined): RibbonControlProps => {
        const controlInfo = getControlInfo(MailRibbonControlId.Poll);
        return createMailAppButton(
            getComposeRibbonId(MailRibbonControlId.Poll, popoutComposeViewState),
            controlInfo.text,
            controlInfo.tooltip,
            popoutComposeViewState != undefined /*isPopout*/,
            onPollButtonClicked,
            constructKeytip(
                [getKeytipString(MailRibbonTabId.Tab_Insert)],
                getKeytipString(MailRibbonControlId.Poll)
            ),
            controlInfo.iconName
        );
    }
);
